<template>
  <form @submit.prevent="save">
    <div class="nk-block">
      <div class="nk-block-head">
        <h5 class="title">Recibos de nómina</h5>
        <p></p>
      </div><!-- .nk-block-head -->
      <div v-if="!recibos.length" class="alert alert-info">
        <p>Aún no se ha añadido ningún recibo, da clic en <b>Agregar Recibo</b> para añadir uno.</p>
      </div>
      <div v-for="recibo in recibos" :key="recibo.id_recibo" class="row">
        <div class="col-12 d-flex align-items-end justify-content-end">
          <button type="button" class="btn btn-outline-danger" @click.prevent="remove(recibo)">Eliminar registro
          </button>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-label">Fecha del Recibo</label>
            <input type="date" class="form-control" v-model.lazy="recibo.fecha">
          </div>
        </div>
        <div class="col-sm-6 mt-3">
          <div class="form-group">
            <label class="form-label">Recibo</label>
            <Uploader
                :preFiles="$filters.getFiles(recibo.f_recibo?.id_archivo)"
                :server="$filters.getServer(model)"
                v-model:file="recibo.f_recibo"
            />
          </div>
        </div>
      </div>
      <div class="w-100 text-right">
        <button type="button" class="mt-2 btn btn-lg btn-info" @click.prevent="add">Agregar Recibo</button>
      </div>
    </div><!-- .nk-block -->
  </form>
</template>

<script>
import {useApi} from "@/use/useApi";
import {reactive, toRefs, defineComponent, computed, watch} from 'vue';
import {useRouter} from 'vue-router';
import Swal from "sweetalert2";
import Uploader from "@/components/globales/Uploader";

const {v4: uuidv4} = require('uuid');

export default defineComponent({
  name: "RecibosNomina",
  components: {
    Uploader
  },
  props: ['empleado'],
  setup(params) {
    //Data
    const {loading, make} = useApi();
    const router = useRouter();

    const model = computed(() => {
      return params.empleado;
    });

    const state = reactive({
      recibos: [],
      inited: false
    });

    //Methods
    async function get() {
      loading.message = 'Obteniendo información';
      let {data} = await make('empleados/recibos-nomina/get', {id_empleado: model.value.id_empleado});
      if (data === null) {
        await Swal.fire('Error', 'Ocurrió un error al conectarse con el servidor', 'error');
        router.go();
      } else {
        if (data.error) {
          await Swal.fire('Error', data.message, 'error');
        } else {
          state.recibos = data.recibos;
        }
      }
    }

    async function save() {
      loading.message = 'Actualizando información';
      //Save
      let {data} = await make('empleados/recibos-nomina/edit', {
        model: state.recibos,
        id_empleado: model.value.id_empleado
      });
      if (data === null) {
        await Swal.fire('Error', 'Ocurrió un error al conectarse con el servidor', 'error');
      } else {
        if (data.error) {
          await Swal.fire('Error', data.message, 'error');
        }
      }
    }

    function add() {
      state.recibos.push({
        id_recibo: uuidv4(),
        fecha: null,
        f_recibo: {
          id_archivo: false,
          estatus: 'Pendiente',
          url: '#',
          autorizo: '',
          subio: '',
          nombre: ''
        }
      });
    }

    function remove(recibo) {
      state.recibos = state.recibos.filter(_recibo => _recibo.id_recibo !== recibo.id_recibo);
    }


    watch(() => state.recibos, () => {
      if (state.inited) {
        save();
      } else {
        state.inited = true;
      }
    }, {deep: true});

    get();

    return {
      model, ...toRefs(state),
      loading,
      save,
      get,
      add, remove
    };
  }
});
</script>

<style scoped>
textarea.form-control {
  min-height: 75px;
}

.form-label {
  text-transform: uppercase;
}
</style>